

import { useState, useEffect } from "react";
import {
  FaArrowCircleLeft,
  FaTrash,
  FaPlusCircle,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./PurchaseReturn.css";
  import { FaSearch } from "react-icons/fa";
  import { showSuccess, showError, showWarning } from "../../General/Toast";

const PurchaseReturn = ({ clientData ,role}) => {
  const navigate = useNavigate();



const [ReturnDate, setReturnDate] = useState(
  new Date().toISOString().split("T")[0]
);
  const [partyId, setPartyId] = useState("");
  const [partyName, setPartyName] = useState("");
    const [partyAddress, setPartyAddress] = useState("");
      const [partyGst, setPartyGst] = useState("");
         const [partyNo, setPartyNo] = useState("");
  const [purchaseBill, setPurchaseBill] = useState([]);
  const [returnAgainst, setReturnAgainst] = useState("");
  const [returnNo, setReturnNo] = useState(clientData?.pur_ret_no || "");

const [totalTax, setTotalTax] = useState(0);
const [received, setReceived] = useState(0);
const [due, setDue] = useState(0);
  const [unit, setunit] = useState([]);
  const [category, setCategory] = useState([]);
  const [visitParty, setVisitParty] = useState(0);

  const [originalTotalPur, setOriginalTotalPur] = useState(0);
const [previousBalance, setPreviousBalance] = useState(0);
const [isIGSTBill, setIsIGSTBill] = useState(false);
const [mode, setMode] = useState("");
const [paymentMethod, setPaymentMethod] = useState("");
const [cbPayId, setCbPayId] = useState("");

const [lastDiscount, setLastDiscount] = useState(0);
const [lastDiscountType, setLastDiscountType] = useState("Amount");
const [onChangeForDiscount, setOnChangeForDiscount] = useState(0);
const [accId, setAccId] = useState("");


  const [rows, setRows] = useState([
    {
      id: 1,
      name: "",
      category: "",
      unit: "",
      price: "",
      quantity: "",
      tax: "",
      amount: "",
    },
  ]);


  const fetchPurchase = async () => {
    try {
      const res = await axios.get(
        `https://api.dectwinbilling.com/fetch-purchase-bill/${clientData.id}`
      );
      setPurchaseBill(res.data);
    } catch (err) {
      console.log(err);
    }
  };

    const fetchUnit = async () => {
      try {
        const res = await axios.get(`https://api.dectwinbilling.com/fetch-unit/${clientData.id}`);
        setunit(res.data);
  
      } catch (error) {
        console.log(error);
      }
    };
  
    const fetchCategory = async () => {
      try {
        const res = await axios.get(`https://api.dectwinbilling.com/fetch-category/${clientData.id}`);
        const filterCat =
          setCategory(res.data);
  
      } catch (error) {
        console.log(error);
      }
    };

  useEffect(() => {
    fetchPurchase();
    fetchCategory();
    fetchUnit();
  }, []);



  
  const addRow = () => {
    setRows([
      ...rows,
      {
        id: rows.length + 1,
        name: "",
        category: "",
        unit: "",
        price: "",
        quantity: "",
        tax: "",
        amount: "",
      },
    ]);
  };

  
const handleRowChange = (index, field, value) => {
  const updated = [...rows];
  updated[index][field] = value;
  setRows(updated);
};



 const handleSearchPurchase = async () => {
  if (!returnAgainst) {
    showWarning("Please enter invoice number");
    return;
  }

  try {
    const response = await axios.get(
      `https://api.dectwinbilling.com/fetch-purchase-detail/${returnAgainst}`
    );

   const data = response.data[0];



    // Party Details
    setPartyId(data.party_id)
    setPartyName(data.name);
    setPartyAddress(data.address);
    setPartyGst(data.gstin)
    setPartyNo(data.mobile);
    setTotalTax(data.totalTax || 0);
    setReceived(data.received || 0);
    setDue(data.due || 0);
    setVisitParty(data.visits || 0 );

setOriginalTotalPur(data.total_pur || 0);
setPreviousBalance(data.balance || 0);



setMode(data.mode || "");
setPaymentMethod(data.payment_method || "");
setCbPayId(data.cb_payid || "");
setAccId(data.acc_id || "");


setLastDiscount(Number(data.last_discount || 0));
setLastDiscountType(data.last_discount_type || "Amount");
setOnChangeForDiscount(Number(data.onChangeForDiscount || 0));

    // Parse Items
    const parsedItems = JSON.parse(data.items || "[]");
    
setIsIGSTBill(Number(data.igst) > 0);
    const isIGST = Number(data.igst) > 0;
const totalTax = Number(data.totalTax || 0);
const sgst = isIGST ? 0 : totalTax / 2;
const cgst = isIGST ? 0 : totalTax / 2;
const igst = isIGST ? totalTax : 0;

setRows(
  parsedItems.map((item, index) => {
    const taxRate = Number(data.cgst + data.sgst);

    return {
      id: index + 1,
      name: item.name,
      category: item.category,
      unit: item.unit,
      price: item.pur_price,
      qty: item.qty,
      amount: item.amount,

      taxRate: Number(data.cgst + data.sgst),
      taxMode: isIGST ? "IGST" : "GST",

       barcode: item.barcode || "",
      hsn_code: item.hsn_code || "",
       purchase_price: item.pur_price || 0,
      price: item.pur_price || 0,
      sale_price: item.sale_price || 0,
      mrp: item.mrp || 0,
      wholesale_price: item.wholesale || item.wholesale_price || 0,
       discount: item.discount || 0,
      dis_in_percent: item.dis_in_percent || "Amount",
      pur_price_withTax: item.pur_price_withTax || "With Tax",
      sale_price_withTax: item.sale_price_withTax || "With Tax",
    };
  })
);
  } catch (error) {
    console.error(error);
    showError("Purchase not found");
  }
};

const totalQty = rows.reduce(
  (sum, row) => sum + Number(row.qty || 0),
  0
);

const totalAmount = rows.reduce(
  (sum, row) => sum + Number(row.amount || 0),
  0
);

const returnAmount = rows.reduce(
  (sum, row) => sum + Number(row.amount || 0),
  0
);

const payableAmount = totalAmount;

// const handleSavePurchaseReturn = async () => {
//   try {

// const isIGST = isIGSTBill;

//     const totalGST = rows.reduce(
//       (sum, row) => sum + Number(row.taxRate || 0),
//       0
//     );

//     const sgst = isIGST ? 0 : totalGST / 2;
//     const cgst = isIGST ? 0 : totalGST / 2;
//     const igst = isIGST ? totalGST : 0;

//     const totalSP = rows.reduce(
//       (sum, row) => sum + Number(row.qty || 0) * Number(row.price || 0),
//       0
//     );

//   const payload = {

//   inv_against: returnAgainst,

//   cust_name: partyName,
//   cust_address: partyAddress,
//   cust_number: partyNo,
//   gstin: partyGst,

//   dateTime: ReturnDate,

//   payable: payableAmount,



//   itemsAdded: 1,

//   mode,
//   payment_method: paymentMethod,
//   cb_payid: cbPayId,

//   last_discount: lastDiscount,
//   last_discount_type: lastDiscountType,
//   onChangeForDiscount: onChangeForDiscount,
//   acc_id: accId,

//   items: rows.map((row) => ({
//     ...row,


//     qty: Number(row.qty || 0),

//     // Current inventory stock
//     stock: Number(row.stock || 0),

//     amount:
//       Number(row.qty || 0) *
//       Number(row.pur_price || 0),
//   })),

//   sgst,
//   cgst,
//   igst,

//   totalSP,
//   totalTax: totalGST,

//   client_type: role,

//   pId: partyId,

//   visits:
//     Number(visitParty || 0) + 1,

//   total_pur:
//     Number(originalTotalPur || 0) -
//     Number(returnAmount || 0),

//   balance:
//     Number(previousBalance || 0) +
//     Number(returnAmount || 0),

//   last_visit: new Date(),
// };
//     const res = await axios.post(
//       `https://api.dectwinbilling.com/api/purchase-return-bill/${clientData.id}`,
//       payload
//     );

//        showSuccess("Purchase Return Saved Successfully", "success");
//              navigate("/invoice-preview", {
//     state: {
//       invoice: {
//         ...payload,
//         invoiceNo:
//           res.data?.invoiceNo ||
//           res.data?.data?.invoiceNo
//       },
//        billTitle: "PURCHASE RETURN"
//     }
//   });
//        resetForm()

//   } catch (error) {
//     console.error(error);
//     showError(
//       error.response?.data?.message || "Purchase return failed",
//       "error"
//     );
//   }
// };
const handleSavePurchaseReturn = async () => {
  try {

    /* =====================================================
       1. PURCHASE BILL VALIDATION
    ===================================================== */

    if (!returnAgainst || !String(returnAgainst).trim()) {
      showWarning("Please select a purchase bill first");
      return;
    }


    /* =====================================================
       2. PARTY VALIDATION
    ===================================================== */

    if (!partyId || !partyName || !String(partyName).trim()) {
      showWarning("Please select a party first");
      return;
    }


    /* =====================================================
       3. EMPTY ITEM VALIDATION
    ===================================================== */

    if (!Array.isArray(rows) || rows.length === 0) {
      showWarning("Please add at least one item");
      return;
    }


    /* =====================================================
       4. CHECK BLANK / INVALID ITEMS
    ===================================================== */

    const invalidRow = rows.find((row) => {

      const itemName = String(row.name || "").trim();

      const qty = Number(row.qty || row.quantity || 0);

      const price = Number(
        row.pur_price ??
        row.purchase_price ??
        row.price ??
        0
      );

      return (
        !itemName ||
        qty <= 0 ||
        price <= 0
      );
    });


    if (invalidRow) {
      showWarning(
        "Please add item, quantity and price before saving"
      );
      return;
    }


    /* =====================================================
       5. MAKE SURE THERE IS A REAL RETURN AMOUNT
    ===================================================== */

    const validRows = rows.filter((row) => {

      const qty = Number(row.qty || row.quantity || 0);

      const price = Number(
        row.pur_price ??
        row.purchase_price ??
        row.price ??
        0
      );

      return (
        String(row.name || "").trim() &&
        qty > 0 &&
        price > 0
      );
    });


    if (validRows.length === 0) {
      showWarning("Purchase return cannot be empty");
      return;
    }


    /* =====================================================
       6. CALCULATE GST
    ===================================================== */

    const isIGST = isIGSTBill;

    const totalGST = validRows.reduce(
      (sum, row) =>
        sum + Number(row.taxRate || 0),
      0
    );

    const sgst = isIGST
      ? 0
      : totalGST / 2;

    const cgst = isIGST
      ? 0
      : totalGST / 2;

    const igst = isIGST
      ? totalGST
      : 0;


    /* =====================================================
       7. TOTAL SELLING / PURCHASE RETURN AMOUNT
    ===================================================== */

    const totalSP = validRows.reduce(
      (sum, row) =>
        sum +
        Number(row.qty || row.quantity || 0) *
        Number(
          row.price ??
          row.pur_price ??
          row.purchase_price ??
          0
        ),
      0
    );


    const returnAmount = validRows.reduce(
      (sum, row) =>
        sum +
        Number(row.qty || row.quantity || 0) *
        Number(
          row.pur_price ??
          row.purchase_price ??
          row.price ??
          0
        ),
      0
    );


    /* =====================================================
       8. FINAL AMOUNT VALIDATION
    ===================================================== */

    if (returnAmount <= 0) {
      showWarning(
        "Purchase return amount should be greater than 0"
      );
      return;
    }


    /* =====================================================
       9. CREATE PAYABLE AMOUNT
    ===================================================== */

    const payableAmount = returnAmount;


    /* =====================================================
       10. CREATE PAYLOAD
    ===================================================== */

    const payload = {

      inv_against: returnAgainst,

      cust_name: partyName,

      cust_address: partyAddress,

      cust_number: partyNo,

      gstin: partyGst,

      dateTime: ReturnDate,

      payable: payableAmount,

      itemsAdded: validRows.length,

      mode,

      payment_method: paymentMethod,

      cb_payid: cbPayId,

      last_discount: lastDiscount,

      last_discount_type: lastDiscountType,

      onChangeForDiscount:
        onChangeForDiscount,

      acc_id: accId,


      /* =================================================
         ITEMS
      ================================================= */

      items: validRows.map((row) => ({

        ...row,

        qty: Number(
          row.qty || row.quantity || 0
        ),

        stock: Number(
          row.stock || 0
        ),

        amount:
          Number(
            row.qty || row.quantity || 0
          ) *
          Number(
            row.pur_price ??
            row.purchase_price ??
            row.price ??
            0
          ),

      })),


      sgst,

      cgst,

      igst,

      totalSP,

      totalTax: totalGST,

      client_type: role,

      pId: partyId,

      visits:
        Number(visitParty || 0) + 1,


      total_pur:
        Number(originalTotalPur || 0) -
        Number(returnAmount || 0),


      balance:
        Number(previousBalance || 0) +
        Number(returnAmount || 0),


      last_visit: new Date(),

    };


    /* =====================================================
       11. FINAL SAFETY CHECK
    ===================================================== */

    if (
      !payload.items ||
      payload.items.length === 0 ||
      Number(payload.payable || 0) <= 0
    ) {
      showWarning(
        "Empty purchase return cannot be saved"
      );
      return;
    }


    /* =====================================================
       12. SAVE API
    ===================================================== */

    const res = await axios.post(
      `https://api.dectwinbilling.com/api/purchase-return-bill/${clientData.id}`,
      payload
    );


    /* =====================================================
       13. SUCCESS
    ===================================================== */

    showSuccess(
      "Purchase Return Saved Successfully",
      "success"
    );


    /* =====================================================
       14. PREVIEW
    ===================================================== */

    navigate("/invoice-preview", {
      state: {
        invoice: {

          ...payload,

          invoiceNo:
            res.data?.invoiceNo ||
            res.data?.data?.invoiceNo,

        },

        billTitle: "PURCHASE RETURN",

      },
    });


    /* =====================================================
       15. RESET
    ===================================================== */

    resetForm();


  } catch (error) {

    console.error(
      "Purchase Return Save Error:",
      error
    );

    showError(
      error?.response?.data?.message ||
      "Failed to save purchase return"
    );

  }
};

const resetForm = () => {
  setReturnDate(new Date().toISOString().split("T")[0]);

  setPartyName("");
  setPartyAddress("");
  setPartyGst("");
  setPartyNo("");

  setReturnAgainst("");

  setTotalTax(0);
  setReceived(0);
  setDue(0);

  setVisitParty(0);
  setOriginalTotalPur(0);
  setPreviousBalance(0);

  setRows([
    {
      id: 1,
      name: "",
      category: "",
      unit: "",
      price: "",
      qty: "",
      tax: "",
      amount: "",
      taxMode: "GST",
      taxRate: 0,
      taxType: "Without Tax",
    },
  ]);
};
  return (
    <div className="page-wrapper">

       <div className="page-content">

      <div className="page-header">
        <FaArrowCircleLeft
          style={{ cursor: "pointer" }}
          onClick={() => navigate("/purchase")}
        />
        Purchase Return
      </div>

      <div className="container-fluid mt-3">
        <div className="row g-3">

          {/* LEFT CARD */}
          <div className="col-md-4">
        

<div className="card-box">
  <strong>Return Against</strong>

  <div className="input-group mt-2">
    <input
      className="form-control"
      placeholder="Enter Invoice Number"
      value={returnAgainst}
      onChange={(e) => setReturnAgainst(e.target.value)}
    />

    <button
      className="btn btn-primary"
      onClick={handleSearchPurchase}
    >
      <FaSearch />
    </button>
  </div>

  <strong className="mt-3 d-block">Party Name</strong>
  <input
    className="form-control mt-2"
    value={partyName}
    disabled
  />


      {/* <label className="form-label fw-semibold mt-3">
      Return Date
    </label>

    <input
      type="date"
      className="form-control rounded-3"
      value={ReturnDate}
      onChange={(e) => setReturnDate(e.target.value)}
    /> */}
</div>


          </div>

    
    <div className="col-md-4 ms-auto">
  <div className="card-box">

{/* 
    <div className="mb-3">
      <label className="form-label fw-semibold">
        Return No
      </label>

      <input
        type="text"
        className="form-control rounded-3"
        value={returnNo}
        readOnly
      />
    </div> */}

    {/* Return Date */}
    <div>
      <label className="form-label fw-semibold">
        Return Date
      </label>

      <input
        type="date"
        className="form-control rounded-3"
        value={ReturnDate}
        onChange={(e) => setReturnDate(e.target.value)}
      />
    </div>

  </div>
</div>

        </div>
      </div>

      <div className="container-fluid mt-3">
        <div className="table-wrapper p-2">

          <table className="table table-bordered custom-table mb-0">

            <thead>
              <tr>
                <th>S.No</th>
                <th>Item</th>
                <th>Category</th>
                <th>Unit</th>
                <th>Price</th>
                <th>Qty</th>
                <th>Tax</th>
                <th>Amount</th>
              </tr>
            </thead>

    <tbody>
  {rows.map((row, index) => (
    <tr key={row.id}>
      <td>
        <div className="d-flex align-items-center gap-2">
          <span>{index + 1}</span>

          <FaTrash
            color="red"
            style={{ cursor: "pointer" }}
            onClick={() =>
              setRows(rows.filter((_, i) => i !== index))
            }
          />
        </div>
      </td>

   <td>
  <input
    className="form-control form-control-sm"
    value={row.name || ""}
    readOnly
  />
</td>


<td>
  <select
    className="form-select form-select-sm"
    value={row.category || ""}
    onChange={(e) => {
      const updatedRows = [...rows];
      updatedRows[index].category = e.target.value;
      setRows(updatedRows);
    }}
  >
    <option value="">Select Category</option>

    {category.map((cat) => (
      <option
        key={cat.id}
        value={cat.cat_name}
      >
        {cat.cat_name}
      </option>
    ))}
  </select>
</td>


<td>
  <select
    className="form-select form-select-sm"
    value={row.unit || ""}
    onChange={(e) => {
      const updatedRows = [...rows];
      updatedRows[index].unit = e.target.value;
      setRows(updatedRows);
    }}
  >
    <option value="">Select Unit</option>

    {unit.map((u) => (
      <option
        key={u.id}
        value={u.cat_name}
      >
        {u.cat_name}
      </option>
    ))}
  </select>
</td>


<td>
<input
  type="number"
  className="form-control form-control-sm"
  value={row.price || ""}
  onChange={(e) => {
    const updatedRows = [...rows];

    const price = Number(e.target.value) || 0;
    const qty = Number(updatedRows[index].qty) || 0;

    updatedRows[index].price = price;
    updatedRows[index].amount = qty * price;

    setRows(updatedRows);
  }}
/>
</td>


<td>
<input
  type="number"
  className="form-control form-control-sm"
  value={row.qty || ""}
  onChange={(e) => {
    const updatedRows = [...rows];

    const qty = Number(e.target.value) || 0;
    const price = Number(updatedRows[index].price) || 0;

    updatedRows[index].qty = qty;
    updatedRows[index].amount = qty * price;

    setRows(updatedRows);
  }}
/>
</td>


<td>
  <div className="d-flex gap-2">

    {/* Tax Type (Disabled) */}
    <select
      className="form-select form-select-sm"
      style={{ width: "120px" }}
      value={row.taxType || "Without Tax"}
      disabled
    >
      <option value="With Tax">With Tax</option>
      <option value="Without Tax">Without Tax</option>
    </select>

    {/* Tax Rate (Disabled) */}
    <select
      className="form-select form-select-sm"
      style={{ width: "140px" }}
      // value={`${row.taxMode || "GST"}-${row.taxRate || ""}`}
      value={`${row.taxMode ?? (row.igst > 0 ? "IGST" : "GST")}-${row.taxRate || ""}`}
      disabled
    >
      <option value="">Tax Rate</option>

      <option value="GST-0">GST 0%</option>
      <option value="IGST-0">IGST 0%</option>

      <option value="GST-0.25">GST 0.25%</option>
      <option value="IGST-0.25">IGST 0.25%</option>

      <option value="GST-3">GST 3%</option>
      <option value="IGST-3">IGST 3%</option>

      <option value="GST-5">GST 5%</option>
      <option value="IGST-5">IGST 5%</option>

      <option value="GST-12">GST 12%</option>
      <option value="IGST-12">IGST 12%</option>

      <option value="GST-18">GST 18%</option>
      <option value="IGST-18">IGST 18%</option>

      <option value="GST-28">GST 28%</option>
      <option value="IGST-28">IGST 28%</option>
    </select>

  </div>
</td>

<td>₹ {Number(row.amount || 0).toFixed(2)}</td>


    </tr>
  ))}
</tbody>

          </table>

          <div className="text-center mt-2">
            <FaPlusCircle
              size={35}
              color="var(--primary-color)"
              style={{ cursor: "pointer" }}
              onClick={addRow}
            />
          </div>

        </div>
      </div>

      <div className="container-fluid mt-3">
      <div className="summary-box">
  <div className="summary-left">
    <strong>Total</strong>
  </div>

  <div className="summary-right">
    <div>{totalQty} </div>
    <div></div>
    <div>{totalTax}</div>
    <div>₹ {totalAmount}</div>
  </div>
</div>
      </div>

 <div className="container-fluid mt-3 mb-3">
  <div className="row justify-content-end">

    <div className="col-md-3">
      <div className="card-box d-flex align-items-center justify-content-between">


    <strong className="">
      Payable Amount
    </strong>

   <span className="fw-bold text-success">
  ₹ {payableAmount}
</span>



      </div>
    </div>

  </div>
</div>
  
 </div>
 
 <div className="footer-bar mt-4">
    <button className="btn-clear btn btn-secondary" onClick={() => resetForm()} >Clear Bill</button>
    <button className="btn-save btn btn-success" onClick={handleSavePurchaseReturn} >Save & Print</button>
    <button className="btn-preview btn btn-primary" onClick={handleSavePurchaseReturn} >Preview & Share</button>
  </div>

    </div>
  );
};

export default PurchaseReturn;
